module.exports = __webpack_public_path__ + "img/base-card.58180c51.png";